// import http from '../api/http'

const authRoutes = [
  // {
  //   path: "/auth/password/edit",
  //   name: "ChangePassword",
  //   beforeEnter(to, from, next) {
  //     // Put the full page url including the protocol http(s) below
  //     console.log('going to other page');
  //     let base = process.env.VUE_APP_API_BASE? 'http://localhost:3000' : 'https://app.checkbits.com.br'
  //     let url = process.env.VUE_APP_API_BASE || "/"; 
  //     http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  //     setTimeout(() => {
  //       http.get(base + to.fullPath).then(d=>{
  //         console.log(d);
          
  //       })
  //       // window.location = "http://localhost:3000"+to.fullPath
  //     }, 5200);
  //   },
  //   // component: () => import("./pages/ChangePassword.vue"),
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("./pages/Login.vue"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("./pages/Logout.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./pages/Register.vue"),
  },
  {
    path: "/recover",
    name: "Recover",
    component: () => import("./pages/Recover.vue"),
  },
  {
    path: "/password",
    name: "Password",
    component: () => import("./pages/Password.vue"),
    meta: {
      auth: false,
    },
  },
];

export default authRoutes;
